/*
  Bulk upload appointments
 */

import { Request } from "mssql";
import { ApplicationScope } from "../ApplicationScope";
import * as csv from "json2csv";
import { R4Appointment } from "../R4Patient";

export const bulkUploadAppointments = async (
  applicationScope: ApplicationScope,
  minApptId: number,
  maxApptId: number
) => {
  try {
    const req: Request = await applicationScope.connectionPool.request();
    req.input("minApptId", minApptId);
    req.input("maxApptId", maxApptId);

    applicationScope.logging.log({
      message: `Appointment bulk upload trigger from ApptId ${minApptId} to ${maxApptId}`,
    });

    const result = await req.query(`
      select ats.PatientCode, 
        ats.ApptId, 
        ats.ApptDateTime,
        ats.ApptFlag,
        f."Description"
      from Appts ats
        left join ApptFlags f on f.ApptFlag = ats.ApptFlag
      where ats.ApptId >= @minApptId and ats.ApptId <= @maxApptId`);

    if (result.recordset.length === 0) {
      applicationScope.logging.log({
        message: "No appointment found for bulk upload!",
      });
      return;
    }

    const csvData: R4Appointment[] = result.recordset.map((row) => {
      return {
        apptId: row["ApptId"].toString(),
        patientCode: row["PatientCode"],
        apptDateTime: row["ApptDateTime"],
        statusCode: row["ApptFlag"],
        status: row["Description"],
      };
    });

    console.log(
      `start sync appointment from ${minApptId} to ${maxApptId} with ${csvData.length} results`
    );
    const csvText = csv.parse(csvData, { header: true });
    await applicationScope.flynotesServer.appointmentBulkUpload(
      csvText,
      applicationScope.licenceKey
    );
  } catch (e) {
    applicationScope.logging.log(
      {
        message: `Appointment bulk upload sync failed ${e}`,
        error: e,
      },
      "error"
    );
  }
};

const CHUNK_SIZE = 500;

export const bulkUploadAppointmentsChunked = async (
  applicationScope: ApplicationScope,
  startingIndex: number
): Promise<number> => {
  const result = await applicationScope.connectionPool
    .request()
    .query(
      `SELECT max(p.ApptId) as max_appt_id, min(p.ApptId) as min_appt_id from Appts p`
    );

  const maxApptId = result.recordset[0]["max_appt_id"];
  const minApptId = result.recordset[0]["min_appt_id"];

  if (!maxApptId) {
    applicationScope.logging.log({
      message: "No appointments found for bulk upload!",
      maxPatientCode: maxApptId,
    });

    return 0;
  }

  applicationScope.logging.log({
    message: `Buld upload appointments minApptId: ${minApptId} to maxApptId: ${maxApptId}`,
    maxPatientCode: maxApptId,
  });

  // Codes don't start at 0, so we can save some time by going straight to minPatientCode
  let index = minApptId > startingIndex ? minApptId : startingIndex;

  while (index <= maxApptId) {
    await bulkUploadAppointments(applicationScope, index, index + CHUNK_SIZE);
    index += CHUNK_SIZE;
  }

  return maxApptId;
};
